/**
 * Created by RKL on 07/09/2015.
 */
define('adminLmbAnaDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'adminLmbAnaDetailsView',
  'emptyView',
  'lmbAnaDetailTabController',
  'adminResTransController',
  'adminLmbAnaAnaAssayController',
  'rolesMixin',
  'settings',
  'entities/lmbanas'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  lmbAnaDetailTabController,
  adminResTransController,
  adminLmbAnaAnaAssayController
) {
  'use strict';

  var LmbAnasDetailsController = {
    fetchLmbAna: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showLmbAna(data);
      } else {
        this.model = App.request('lmbana:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showLmbAna(data);
          }
        });
      }
    },

    showLmbAna: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'lmbana:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (lmbAna) {
      this.view.onHeaderChange(lmbAna);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      if (data.tab) {
        switch (data.tab.name) {
          case 'anaassay':
            adminLmbAnaAnaAssayController.showAnaAssayList(data);
            break;
          case 'restrans':
            adminResTransController.showResTransList(data);
            break;
          default:
            lmbAnaDetailTabController.showTab(data);
            break;
        }
      } else {
        lmbAnaDetailTabController.showTab(data);
      }

      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('admin/lmbanas/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = LmbAnasDetailsController;
});
